import { SEARCH_GRID_DESKTOP_MIN_COLUMN_PX } from './searchResultsPanelLayout';

/**
 * Image `sizes` for the search grid variant.
 * Matches SearchPage.layoutWrapperMain mobile padding (16px × 2) and grid gap (14px).
 */
export const SEARCH_GRID_MOBILE_HORIZONTAL_INSET_PX = 32;
export const SEARCH_GRID_MOBILE_GAP_PX = 14;

export const getSearchGridMobileCardRenderSize = () =>
  `calc((100vw - ${SEARCH_GRID_MOBILE_HORIZONTAL_INSET_PX + SEARCH_GRID_MOBILE_GAP_PX}px) / 2)`;

/**
 * @param {boolean} isMapVariant
 * @returns {string}
 */
export const getSearchResultsCardRenderSizes = isMapVariant => {
  if (isMapVariant) {
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 767px) 100vw',
      `(max-width: 1023px) ${panelMediumWidth}vw`,
      `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
      `${panelLargeWidth / 3}vw`,
    ].join(', ');
  }

  const minColumnPx = SEARCH_GRID_DESKTOP_MIN_COLUMN_PX;
  return [
    `(max-width: 767px) ${getSearchGridMobileCardRenderSize()}`,
    `(max-width: 1023px) 33vw`,
    `(max-width: 1439px) 28vw`,
    `(max-width: 1920px) ${minColumnPx}px`,
    `${minColumnPx}px`,
  ].join(', ');
};
